import { getCurrency, getPercentage } from 'globals/utils';
import { CategorySingleItemProps } from './category-single-item';

export interface CategoryRowDataProps {
  categoryName: string;
  category?: string;
  value: number;
  displayValue: string;
  percentage: string;
  subcategories?: CategoryRowDataProps[];
  areTransactions: boolean;
  areSubcategories: boolean;
  id: string;
}

export const mapCategories = (
  array: Array<CategorySingleItemProps>
): CategoryRowDataProps[] => {
  return array.map(
    ({
      id,
      name,
      subcategories,
      category_stat: { category, percent, total },
    }) => ({
      id,
      categoryName: name,
      category,
      value: total,
      displayValue: getCurrency({ value: total }),
      percentage: getPercentage(percent),
      subcategories: subcategories ? mapCategories(subcategories) : undefined,
      areTransactions: total > 0,
      areSubcategories: !!(subcategories && subcategories.length > 0),
    })
  );
};

export default {
  mapCategories,
};
